export let i18n = {};

export function initI18n(container) {
  if (container && container.dataset.i18n) {
    try {
      i18n = JSON.parse(container.dataset.i18n);
    } catch (e) {
      console.error("Failed to parse i18n", e);
    }
  }
}

export function t(key, fallback) {
  return i18n[key] || fallback;
}
